/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Jolly_Early_Crossbill_TreatInputs */

const fr_jolly_early_crossbill_treat = /** @type {(inputs: Jolly_Early_Crossbill_TreatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Titre`)
};

/**

* @param {Jolly_Early_Crossbill_TreatInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const jolly_early_crossbill_treat = /** @type {((inputs?: Jolly_Early_Crossbill_TreatInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Jolly_Early_Crossbill_TreatInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_jolly_early_crossbill_treat(inputs)
});